import { Injectable } from "@angular/core";
import { DateFnsAdapter } from "@angular/material-date-fns-adapter";
import { DateAdapter } from "@angular/material/core";
import { MatPaginatorIntl } from "@angular/material/paginator";
import { TranslateService } from "@ngx-translate/core";
import { frCA } from "date-fns/locale";
import { I18nUtils } from "../utils/i18n.utils";

@Injectable({ providedIn: "root" })
export class I18nService {
    constructor(private translateService: TranslateService) {}

    public getDatePickLang(): string {
        const lang = this.getDefaultLang();
        if (lang === "fr") {
            return "fr-CA";
        }

        return lang;
    }

    public getDefaultLang(): string {
        const browserLang = localStorage.getItem("lang") || (this.translateService.getBrowserLang() as string);
        if (I18nUtils.SUPPORTED_LANGUAGES.some(x => x === browserLang)) {
            return browserLang;
        }

        return I18nUtils.DEFAULT_LANGUAGE;
    }

    public getAvailableLanguages(): string[] {
        const defaultLang = this.getDefaultLang();
        return I18nUtils.SUPPORTED_LANGUAGES.filter(lang => lang !== defaultLang);
    }

    public setLanguage(language: string): void {
        if (!I18nUtils.SUPPORTED_LANGUAGES.some(x => x === language)) {
            return;
        }

        this.translateService.setDefaultLang(language);
        localStorage.setItem("lang", language);
    }

    public getPaginatorIntl(): MatPaginatorIntl {
        const paginatorIntl = new MatPaginatorIntl();
        paginatorIntl.itemsPerPageLabel = this.translateService.instant("paginator.items_per_page");
        paginatorIntl.getRangeLabel = this.getRangeLabel.bind(this);

        paginatorIntl.nextPageLabel = this.translateService.instant("paginator.next_page");
        paginatorIntl.previousPageLabel = this.translateService.instant("paginator.previous_page");
        paginatorIntl.firstPageLabel = this.translateService.instant("paginator.first_page");
        paginatorIntl.lastPageLabel = this.translateService.instant("paginator.last_page");

        return paginatorIntl;
    }

    public getDateAdapter(): DateAdapter<any> {
        return new DateFnsAdapter(frCA);
    }

    private getRangeLabel(page: number, pageSize: number, length: number): string {
        length = Math.max(length, 0);
        const startIndex = page * pageSize;

        // If the start index exceeds the lists length, do not try and fix the end index to the end.
        const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
        return `${startIndex + 1} - ${endIndex} ${this.translateService.instant("paginator.of")} ${length}`;
    }
}
